<!-- 签到提示音 -->
<template>
  <div class="trial-sound">
    <audio id="theTrialSound" playsinline preload="auto" :src="notificationUrl"></audio>
  </div>
</template>
<script>
  export default {
    name: 'TrialSound',
    data() {
      return {
        audioUnlocked: false, // audiio解锁
        notificationUrl:
          'https://cnstatic01.e.vhall.com/common-static/media/notification_signin.mp3' //签到提示
      };
    },
    methods: {
      play() {
        const myAudio = document.getElementById('theTrialSound');
        if (myAudio) {
          myAudio.volume = 1; // 设置音量1最大
          myAudio.muted = false; // 设置非静音
          const playPromise = myAudio.play();
          if (playPromise && typeof playPromise.then === 'function') {
            playPromise
              .then(() => {
                console.log('播放提示音成功');
              })
              .catch(ex => {
                console.error('播放提示音失败:', ex);
              });
          }
        }
      },
      // 预播放，大部分浏览器的媒体自动播放必须有一次交互
      _prePlay() {
        if (!this.audioUnlocked) {
          const myAudio = document.getElementById('theTrialSound');
          if (myAudio) {
            myAudio.volume = 0; // 设置音量0
            myAudio.muted = true; // 设置静音
            const playPromise = myAudio.play();
            if (playPromise && typeof playPromise.then === 'function') {
              playPromise
                .then(() => {
                  console.log('预播放提示音成功');
                  this.audioUnlocked = true;
                })
                .catch(ex => {
                  console.warn('预播放提示音失败:', ex);
                });
            }
          }
        }
      }
    },
    mounted() {
      this.$nextTick(() => {
        /* prettier-ignore */
        document.body.addEventListener('touchstart', () => {
            this._prePlay();
          },
          { once: true }
        );
        /* prettier-ignore */
        document.body.addEventListener('click', () => {
            this._prePlay();
          },
          { once: true }
        );
      });
    }
  };
</script>
<style lang="less" scoped>
  .trial-sound {
    display: none;
    opacity: 0;
  }
</style>
